import React from 'react';
import {Button} from 'react-bootstrap';
import PropTypes from 'prop-types';

const Therigy_Proprietary_Data = "Therigy Proprietary Data";
const Therigy_Proprietary_Data_details = "Derives model opportunity calculations exclusively from proprietary data from Therigy.";
const Derive_from_Med ="Derive from Med Orders";
const Derive_from_Med_details="Derives model opportunity calculations from a combination of 'Med Order' data uploaded into TherigyVista and Therigy proprietary data.";

function ChangeModal(props) {
    const {toggleModel, loadDefaultProprietaryData, loadMedOrders} = props;
    return ( <>
                <div className="body-content">
                    <h4>{Therigy_Proprietary_Data} :</h4>
                    <p>{Therigy_Proprietary_Data_details}</p>
                    <h4>{Derive_from_Med} :</h4>
                    <p>{Derive_from_Med_details}</p>
                </div>

                <div className="body-footer text-right">
                    <Button type="button" className="submit-btn" size="sm" onClick={loadDefaultProprietaryData}>
                        {Therigy_Proprietary_Data}
                    </Button>
                    
                    <Button type="button" className="submit-btn" size="sm" onClick={loadMedOrders}>
                        {Derive_from_Med}
                    </Button>
                    <Button type="button" className="submit-btn" size="sm" onClick={toggleModel}>
                        Close
                    </Button>
                </div>     
            </> );
  }
  ChangeModal.propTypes = {
    toggleModel: PropTypes.func,
    loadDefaultProprietaryData: PropTypes.func,
    loadMedOrders: PropTypes.func,
  };

  export default ChangeModal;

